"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function useIntersectionObserver(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.threshold, threshold = _c === void 0 ? 0 : _c, _d = _b.root, root = _d === void 0 ? null : _d, _e = _b.rootMargin, rootMargin = _e === void 0 ? "0%" : _e, _f = _b.freezeOnceVisible, freezeOnceVisible = _f === void 0 ? false : _f;
    var elementRef = (0, react_1.useRef)(null);
    var _g = (0, react_1.useState)(), entry = _g[0], setEntry = _g[1];
    var isInView = entry === null || entry === void 0 ? void 0 : entry.isIntersecting;
    var updateEntry = function (_a) {
        var entry = _a[0];
        setEntry(entry);
    };
    (0, react_1.useEffect)(function () {
        var node = elementRef === null || elementRef === void 0 ? void 0 : elementRef.current;
        var hasIOSupport = !!window.IntersectionObserver;
        if (!hasIOSupport || (isInView && freezeOnceVisible) || !node)
            return;
        var observer = new IntersectionObserver(updateEntry, { threshold: threshold, root: root, rootMargin: rootMargin });
        observer.observe(node);
        return function () { return observer.disconnect(); };
    }, [threshold, root, rootMargin, isInView, freezeOnceVisible]);
    return [elementRef, isInView, entry];
}
exports.default = useIntersectionObserver;
//# sourceMappingURL=index.js.map